import { createMuiTheme } from "@material-ui/core/styles";
import createTypography from "@material-ui/core/styles/createTypography";
import createPalette from "@material-ui/core/styles/createPalette";

const palette = createPalette({
    primary: { main: "#013759" },
    secondary: { main: "#40A6AE", contrastText: "#fff" },
})

const theme = createMuiTheme({
    palette
});

const typography = ({
    fontFamily: [
        "Montserrat",
        "Roboto"
    ].join(","),
    h3: {
        color: "#013759",
        [theme.breakpoints.down("sm")]: {
            fontSize: 32
        }
    },
    body2: {
        color: "#555555"
    },
    body1: {
        color: "#888888"
    },
    h6: {
        color: "#013759"
    }
})

theme.typography = createTypography(palette, typography);

export default theme;


// WEBPACK FOOTER //
// ./src/common/theme.ts